import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';
import refreshGreenIcon from '@library/assets/images/icons/refresh-green-icon.svg';
import refreshGreyIcon from '@library/assets/images/icons/refresh-grey-icon.svg';

export interface AutoTradeButtonProps {
  autoTrade: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
  standalone?: boolean;
  onClick: () => void;
}

export const AutoTradeButton = ({
  autoTrade,
  className = '',
  disabled = false,
  label = '',
  onClick,
  standalone = false
}: AutoTradeButtonProps) => {
  return (
    <Button
      className={classNames(
        'border-soFresh-140 focus:border-msJackson flex h-8 items-center border bg-transparent',
        standalone ? 'rounded-md' : 'rounded-r-md',
        className
      )}
      disabled={disabled}
      data-testid="AutoTradeButton"
      onClick={onClick}
      type="button"
    >
      <img
        className="px-2"
        src={autoTrade ? refreshGreenIcon : refreshGreyIcon}
        alt={label}
      />
      <span className="leading-relaxed">{label}</span>
    </Button>
  );
};
